import { IRelationsItem } from '~/repositories/dossiers/store/dossiers.models';
import { CardView } from '~/ui/ui.module';

export enum DOSSIERS_DATA_ENDPOINTS {
  'relations' = 'relations',
  'involved' = 'involved',
  'documents' = 'documents',
  'links' = 'links'
}

export enum DOSSIERS_RELATIONS_CONTEXT {
  'DECREE' = 'DECREE',
  'ROI' = 'ROI',
  'CASE' = 'CASE',
  'CONTACT' = 'CONTACT',
  'DOSSIER' = 'DOSSIER'
}

export const DOSSIERS_RELATIONS_MODULE = {
  [DOSSIERS_RELATIONS_CONTEXT.DECREE]: {
    module: 'EDECISION',
    objectType: DOSSIERS_RELATIONS_CONTEXT.DECREE
  },
  [DOSSIERS_RELATIONS_CONTEXT.ROI]: {
    module: 'EDECISION',
    objectType: DOSSIERS_RELATIONS_CONTEXT.ROI
  },
  [DOSSIERS_RELATIONS_CONTEXT.CASE]: {
    module: 'CASES'
  },
  [DOSSIERS_RELATIONS_CONTEXT.CONTACT]: {
    module: 'CONTACTS'
  },
  [DOSSIERS_RELATIONS_CONTEXT.DOSSIER]: {
    module: 'DOSSIERS'
  }
};

export enum DOSSIERS_INVOLVED_CONTEXT {
  'DOSSIER_MANAGER_GROUP' = 'DOSSIER_MANAGER_GROUP',
  'DOSSIER_MANAGER' = 'DOSSIER_MANAGER',
  'INVOLVED_GROUP' = 'INVOLVED_GROUP',
  'INVOLVED' = 'INVOLVED'
}

export const DOSSIERS_RELATIONS_MENU = [
  DOSSIERS_RELATIONS_CONTEXT.CASE,
  DOSSIERS_RELATIONS_CONTEXT.CONTACT,
  DOSSIERS_RELATIONS_CONTEXT.DECREE,
  DOSSIERS_RELATIONS_CONTEXT.ROI
];

export const DOSSIERS_INVOLVED_MENU = [
  DOSSIERS_INVOLVED_CONTEXT.DOSSIER_MANAGER_GROUP,
  DOSSIERS_INVOLVED_CONTEXT.DOSSIER_MANAGER,
  DOSSIERS_INVOLVED_CONTEXT.INVOLVED_GROUP,
  DOSSIERS_INVOLVED_CONTEXT.INVOLVED
];

export const DOSSIERS_INVOLVED_CONTEXT_ICONS = {
  [DOSSIERS_INVOLVED_CONTEXT.DOSSIER_MANAGER_GROUP]: 'fa-solid fa-users',
  [DOSSIERS_INVOLVED_CONTEXT.DOSSIER_MANAGER]: 'fa-solid fa-user',
  [DOSSIERS_INVOLVED_CONTEXT.INVOLVED_GROUP]: 'fa-solid fa-users',
  [DOSSIERS_INVOLVED_CONTEXT.INVOLVED]: 'fa-solid fa-user'
};

export const DOSSIERS_DATA_CONFIG = [
  {
    endpoint: DOSSIERS_DATA_ENDPOINTS.relations,
    children: [
      {
        endpoint: DOSSIERS_RELATIONS_CONTEXT.DECREE
      },
      {
        endpoint: DOSSIERS_RELATIONS_CONTEXT.ROI
      },
      {
        endpoint: DOSSIERS_RELATIONS_CONTEXT.CASE
      },
      {
        endpoint: DOSSIERS_RELATIONS_CONTEXT.CONTACT
      },
      {
        endpoint: DOSSIERS_RELATIONS_CONTEXT.DOSSIER
      }
    ]
  },
  {
    endpoint: DOSSIERS_DATA_ENDPOINTS.involved
  },
  {
    endpoint: DOSSIERS_DATA_ENDPOINTS.documents
  },
  {
    endpoint: DOSSIERS_DATA_ENDPOINTS.links
  }
];

export const getRelationConfig = (item: IRelationsItem): CardView => ({
  ...item,
  yearNumber: item.reference,
  title: item.subject || item.description,
  info: item.metaData,
  documents: item.documents,
  openTasks: item.openTasks,
  status: item?.status
});
